'use strict';

const callHandlers = (fns, args) => {
  for (let i = 0, len = fns.length; i < len; i++) {
    if (i === len - 1) {
      return fns[i](args);
    }
    fns[i](args);
  }
};

const setHandlersHelper = handler => {
  return handler.length >= 1 ? handler.slice(0, handler.length - 1) : handler;
};

class FetchHandler {
  constructor({
    completeHandlers,
    successHandlers,
    errorHandlers,
    rawResponse = false,
    requestOpts = {},
    url,
  }) {
    this.url = url;

    this.rawResponse = rawResponse;
    this.requestOpts = requestOpts;
    if (!(this.requestOpts.headers instanceof Headers)) {
      this.requestOpts.headers = new Headers();
    }
    this.requestOpts.headers.append('X-Requested-With', 'XMLHttpRequest');
    this.requestOpts.headers.append('Accept', 'application/json');
    this.requestOpts.headers.append('Accept', 'text/html');

    this.completeHandlers = [];
    this.successHandlers = [];
    this.errorHandlers = [];

    this.setHandlers({ completeHandlers, successHandlers, errorHandlers });

    this.fetchInFlight = false;
  }

  returnResponse(response) {
    return response;
  }

  setHandlers({
    completeHandlers = [],
    successHandlers = [],
    errorHandlers = [],
  }) {
    if (typeof completeHandlers === 'function') {
      completeHandlers = [completeHandlers];
    }
    this.completeHandlers = [
      ...setHandlersHelper(this.completeHandlers),
      ...completeHandlers,
      this.returnResponse,
    ];

    if (typeof successHandlers === 'function') {
      successHandlers = [successHandlers];
    }
    this.successHandlers = [
      ...setHandlersHelper(this.successHandlers),
      ...successHandlers,
      this.returnResponse,
    ];

    if (typeof errorHandlers === 'function') {
      errorHandlers = [errorHandlers];
    }
    this.errorHandlers = [
      ...setHandlersHelper(this.errorHandlers),
      ...errorHandlers,
      this.returnResponse,
    ];
  }

  setBody(data, opts) {
    const hasBody = data !== undefined || this.requestOpts.body !== undefined;

    if (hasBody) {
      Object.assign(opts, {
        body: JSON.stringify({ ...this.requestOpts.body, ...data }),
      });
      opts.headers.set('Content-Type', 'application/json');
    }
  }

  initRequestData(data) {
    const opts = {
      ...this.requestOpts,
    };

    this.setBody(data, opts);

    this.request = new Request(this.url, opts);

    this.fetchInFlight = true;
  }

  send(data) {
    if (this.fetchInFlight) {
      return null;
    }

    if (!this.url) {
      throw new Error('url is not defined');
    }

    this.initRequestData(data);

    return fetch(this.request)
      .then(response => {
        if (response.status === 200) {
          return this.rawResponse ? response : response.json();
        } else {
          throw new Error(
            `FetchHandler: request received error with status ${
              response.status
            }`
          );
        }
      })
      .then(this.handleSuccess.bind(this))
      .catch(
        (e => {
          if (this.errorHandlers.length) {
            return this.handleError(e);
          } else {
            throw e;
          }
        }).bind(this)
      )
      .then(this.handleComplete.bind(this));
  }

  handleComplete(response) {
    this.fetchInFlight = false;
    return callHandlers(this.completeHandlers, response);
  }

  handleSuccess(response) {
    return callHandlers(this.successHandlers, response);
  }

  handleError(error) {
    return callHandlers(this.errorHandlers, error);
  }
}

module.exports = FetchHandler;
